export const SIGNATURES               = 'SIGNATURES';
export const SIGNATURE                = 'SIGNATURE';
export const SIGNATURE_ORIGINAL_STATE = 'SIGNATURE_ORIGINAL_STATE';
export const LOADING                  = 'LOADING';